<template>
    <b-form-group label-for="familiarHistory">
        <template slot="label"
            >{{ $t("pages.forms.cardio.familiar-history.title")
            }}<span v-if="required" :class="requiredClasses">*</span></template
        >
        <template slot="description" v-show="!isReviewing"
            >{{ $t("pages.forms.cardio.familiar-history.description1") }}
            <strong
                ><i>{{
                    $t("pages.forms.cardio.familiar-history.description2")
                }}</i></strong
            ></template
        >
        <validation-provider
            :rules="{ required }"
            v-slot="{ dirty, classes, valid, validated, errors }"
        >
            <multiselect
                id="familiarHistory"
                v-model="familiarHistory"
                :options="familiarHistoryOptions"
                :multiple="true"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                label="text"
                track-by="value"
                :taggable="true"
                :placeholder="$t('pages.forms.select-descriptors.placeholder')"
                :deselectLabel="
                    $t('pages.forms.select-descriptors.deselectlabel')
                "
                :selectedLabel="
                    $t('pages.forms.select-descriptors.selectedlabel')
                "
                :selectLabel="$t('pages.forms.select-descriptors.selectlabel')"
                :showLabels="false"
                openDirection="above"
                :class="classes"
                :maxHeight="350"
                @input="familiarHistoryItemSelected"
                v-show="!isReviewing"
                data-cypress-id="familiarHistory"
            />
            <div v-if="(dirty || validated) && !valid" class="invalid-feedback">
                {{ errors[0] }}
            </div>
        </validation-provider>
        <b-form-input
            type="text"
            readonly
            plaintext
            v-show="isReviewing"
            :value="familiarHistoryValue"
        />
    </b-form-group>
</template>

<script>
import FormInputHelpers from "../../../mixins/FormInputHelpers";
import { ValidationProvider } from "vee-validate";
const FAMILIAR_HISTORY_TYPE_NONE = 6;

export default {
    mixins: [FormInputHelpers],
    components: { ValidationProvider },
    data() {
        return {
            familiarHistory: this.value.familiarHistory
        };
    },
    props: {
        value: {
            type: Array,
            default() {
                return {
                    familiarHistory: []
                };
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        reviewing: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        update() {
            this.$emit("input", this.familiarHistory);
        },
        familiarHistoryItemSelected(familiarHistoryOptions) {
            if (!familiarHistoryOptions) {
                return;
            }

            // User has selected other values _AFTER_ select "Ninguna" value
            if (
                familiarHistoryOptions.length === 2 &&
                familiarHistoryOptions[0].value === FAMILIAR_HISTORY_TYPE_NONE
            ) {
                this.familiarHistory = familiarHistoryOptions.filter(
                    t => t.value !== FAMILIAR_HISTORY_TYPE_NONE
                );
                this.update();
                return;
            }

            // User has selected "Ninguna" value
            if (
                familiarHistoryOptions.filter(
                    t => t.value === FAMILIAR_HISTORY_TYPE_NONE
                ).length > 0
            ) {
                this.familiarHistory = [];
                this.familiarHistory.push(
                    // Last position of `familiarHistory` array corresponds to the "Ninguna" value.
                    this.familiarHistoryOptions[
                        this.familiarHistoryOptions.length - 1
                    ]
                );
            }

            this.update();
        }
    },
    computed: {
        familiarHistoryOptions() {
            return [
                {
                    value: 1,
                    text: this.$i18n.t(
                        "pages.forms.cardio.familiar-history.options.op1"
                    )
                },
                {
                    value: 2,
                    text: this.$i18n.t(
                        "pages.forms.cardio.familiar-history.options.op2"
                    )
                },
                {
                    value: 3,
                    text: this.$i18n.t(
                        "pages.forms.cardio.familiar-history.options.op3"
                    )
                },
                {
                    value: 4,
                    text: this.$i18n.t(
                        "pages.forms.cardio.familiar-history.options.op4"
                    )
                },
                {
                    value: 5,
                    text: this.$i18n.t(
                        "pages.forms.cardio.familiar-history.options.op5"
                    )
                },
                {
                    value: 6,
                    text: this.$i18n.t(
                        "pages.forms.cardio.familiar-history.options.op6"
                    )
                }
            ];
        },
        isReviewing() {
            return this.reviewing;
        },
        familiarHistoryValue() {
            if (this.familiarHistory != null) {
                return this.familiarHistory.map(e => e.text).join(", ");
            }

            return this.familiarHistory;
        }
    }
};
</script>

<style scoped></style>
